import script from "./DatasetHistory.vue?vue&type=script&setup=true&lang=js"
export * from "./DatasetHistory.vue?vue&type=script&setup=true&lang=js"

import "./DatasetHistory.vue?vue&type=style&index=0&id=313f9808&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-313f9808"]])

export default __exports__